.checkbox {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  cursor: pointer;
  padding: var(--spacing-2xs);
  border-radius: var(--radius-size-sm);
  transition: all 0.2s ease-in-out;
  outline: none;

  &:hover &__box {
    box-shadow: 0 0 0 1px rgb(0 0 0 / 100%);
  }

  &--disabled {
    pointer-events: none;

    .checkbox__box {
      background-color: var(--color-neutral-neutral-lightest);
      border-color: var(--border-color-secondary);
    }

    .checkbox__input:checked + .checkbox__box {
      background-color: var(--color-neutral-neutral-lightest);
      border-color: var(--border-color-secondary);

      .checkbox__icon {
        color: var(--border-color-secondary);
      }
    }

    .checkbox__label {
      color: var(--text-color-tertiary);
    }
  }

  &__input {
    position: absolute;
    opacity: 0;
    margin: 0;

    @include size(0);
  }

  &__box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    @include size(18px);

    border: var(--border-size-sm) solid var(--border-color-primary);
    background-color: var(--color-neutral-white);
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: var(--radius-size-sm);
  }

  &__icon {
    position: absolute;

    @include size(14px, 11px);

    color: var(--background-color-primary);
    opacity: 0;
    transform: scale(0.8);
    transition: all 0.2s ease-in-out;
  }

  &__input:checked + &__box {
    background-color: var(--color-brand-primary-main);
    border-color: var(--color-brand-primary-main);

    .checkbox__icon {
      opacity: 1;
      transform: scale(1);
    }
  }

  &__input:checked:hover + &__box {
    background-color: var(--action-color-brand-primary-hover);
    border-color: var(--action-color-brand-primary-hover);
  }

  &__input:checked:hover:not(:focus) + &__box {
    box-shadow: none;
  }

  &__input:focus + &__box {
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
  }

  &__label {
    color: var(--text-color-primary);
    user-select: none;
    font-size: map-get($font-sizes, md);
    line-height: 150%;
  }
}
